/**
 * @param state {object} Domain state
 * @param authContextData {object} Keycloak auth data
 * @return {object}
 */
export default (state, authContextData) => {

    state.token = {
        idToken: authContextData.idToken,
        idTokenParsed: authContextData.idTokenParsed,
        refreshToken: authContextData.refreshToken,
        refreshTokenParsed: authContextData.refreshTokenParsed,
        sessionId: authContextData.sessionId,
        subject: authContextData.subject,
        token: authContextData.token,
        tokenParsed: authContextData.tokenParsed
    };

    return state;
};
